import '../../../utils/index.mjs';
import { buildProps } from '../../../utils/vue/props.mjs';

const badgeProps = buildProps({
  value: {
    type: [String, Number],
    default: ""
  },
  max: {
    type: Number,
    default: 99
  },
  isDot: Boolean,
  hidden: Boolean,
  type: {
    type: String,
    values: ["primary", "success", "warning", "info", "danger"],
    default: "danger"
  }
});

export { badgeProps };
//# sourceMappingURL=badge.mjs.map
